import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import FeedbackLawyerConsultationListPage from './pages/FeedbackLawyerConsultationListPage';
import FeedbackLawyerConsultationDetailPage from './pages/FeedbackLawyerConsultationDetailPage';

const FeedbackLawyerConsultationModule: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<FeedbackLawyerConsultationListPage />} />
      <Route path="/:applicationId" element={<FeedbackLawyerConsultationDetailPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default FeedbackLawyerConsultationModule;
